/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import { Text } from '../Text';
import Colors from 'constants/Colors';

export const ValidationErrorText = styled(Text)`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  margin-top: 3px;
  color: ${Colors.DANGER};
  font-weight: 600;
  padding-bottom: 8px;
`;
